<header class="header">

	<div class="header-content">
		<section class="logo">
			<img src="/assets/images/kwo-logo-yellow.png" alt="Logo KWO" (click)="goToHome()">
		</section>

		<!-- <div class="go-back">
			<fa-icon class="back-icon" matSuffix [icon]="['fas', 'arrow-left']"></fa-icon>
			<span><a (click)="goBack()">terug</a></span>
		</div> -->
	</div>

</header>